import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { City } from '../models/city';

interface GetCitiesResponse {
	cities: City[];
	pagination: Pagination;
}

export interface CreateCityPayload {
	name: {
		en: string;
		ar: string;
	};
	active: 1 | 0;
	region_id: number;
}

export const onGetAllCities = () => {
	return axios.get<JsonResponse<City[]>>(`${environment.BASE_API_ENDPOINT}/global/cities`);
};

export const onGetCities = (page = 1) => {
	return axios.get<JsonResponse<GetCitiesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/cities`, {
		params: {
			page,
		},
	});
};

export const onGetCity = (cityId: string) => {
	return axios.get<JsonResponse<City>>(`${environment.BASE_API_ENDPOINT}/admin/cities/${cityId}`);
};

export const onCreateCity = (data: CreateCityPayload) => {
	return axios.post<JsonResponse<City>>(`${environment.BASE_API_ENDPOINT}/admin/cities`, data);
};

export const onUpdateCity = (cityId: string, data: Partial<CreateCityPayload>) => {
	return axios.put<JsonResponse<City>>(`${environment.BASE_API_ENDPOINT}/admin/cities/${cityId}`, data);
};

export const onDeleteCity = (cityId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/cities/${cityId}`);
};
